




























import Vue from 'vue'
import Dialog from '@/components/Dialog.vue'
import { Iterable } from '@/utils/interfaces'
export default Vue.extend({
  components: {
    appDialog: Dialog,
  },
  props: {
    item: {
      type: Object,
      default: () => ({} as object),
      required: false,
    },
  },
  data() {
    return {
      fields: [
        'code',
        'client',
        'phone_number',
        'amount',
        'status',
        'status_code',
        'status_message',
        'carrier_trans_id',
      ],
    }
  },
  computed: {
    data() {
      const item = {} as Iterable
      this.fields.forEach(field => {
        if (this.item[field] || this.item[field] === 0) {
          item[field] = this.item[field]
        }
      })
      return item
    },
  },
  created() {
    if (this.$store.getters.profile.role === 'ADMIN') {
      this.fields.push('provider')
      this.fields.push('shared_provider')
      this.fields.push('uuid')
      this.fields.push('trans_id')
      this.fields.push('order_id')
    }
  },
})
